import {
  FormControl,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { EoFormPanelConfig, EoInputConfig } from 'ngx-eo-web-components';

export const changePasswordSubmitButtonLabel = 'Αλλαγή κωδικού';

function confirmMatchesNew(control: AbstractControl): ValidationErrors | null {
  const parent = control.parent;
  if (!parent) return null;

  const newPwd = parent.get('newPassword')?.value;
  const confirm = control.value;

  if (!newPwd || !confirm) return null;
  return newPwd === confirm ? null : { mismatch: true };
}

function syncConfirm(control: AbstractControl): null {
  const parent = control.parent;
  if (parent) parent.get('confirmPassword')?.updateValueAndValidity();
  return null;
}

export const userChangePasswordFormConfig: EoFormPanelConfig[] = [
  new EoFormPanelConfig({
    header: 'Αλλαγή κωδικού χρήστη',
    name: 'password',
    panelContentStyleClass: 'grid',
    config: [
      new EoInputConfig({
        name: 'oldPassword',
        label: 'Τρέχων κωδικός',
        type: 'password',
        styleClass: 'col-12',
        control: new FormControl('', Validators.required),
      }),

      new EoInputConfig({
        name: 'newPassword',
        label: 'Νέος κωδικός',
        type: 'password',
        styleClass: 'col-12',
        control: new FormControl('', [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$@$!%*#?&]).{8,}$/
          ),
          syncConfirm,
        ]),
      }),

      new EoInputConfig({
        name: 'confirmPassword',
        label: 'Επαναλάβετε τον νέο κωδικό',
        type: 'password',
        styleClass: 'col-12',
        control: new FormControl('', [Validators.required, confirmMatchesNew]),
      }),
    ],
  }),
];
